var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleprocess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#538ED8",
    stroke: "#4785D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1363 11.9996C9.1363 11.6482 8.85138 11.3633 8.49993 11.3633H5.95448C5.60304 11.3633 5.31812 11.6482 5.31812 11.9996C5.31812 12.3511 5.60304 12.636 5.95448 12.636H8.49993C8.85138 12.636 9.1363 12.3511 9.1363 11.9996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0453 11.3633H16.7726C16.4212 11.3633 16.1362 11.6482 16.1362 11.9996C16.1362 12.3511 16.4212 12.636 16.7726 12.636H18.0453C18.3968 12.636 18.6817 12.3511 18.6817 11.9996C18.6817 11.6482 18.3968 11.3633 18.0453 11.3633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.318 8.81818C12.6694 8.81818 12.9544 8.53326 12.9544 8.18182V5.63636C12.9544 5.28492 12.6694 5 12.318 5C11.9666 5 11.6816 5.28492 11.6816 5.63636V8.18182C11.6816 8.53326 11.9666 8.81818 12.318 8.81818Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3182 15.1816C11.9668 15.1816 11.6819 15.4666 11.6819 15.818V18.3635C11.6819 18.7149 11.9668 18.9998 12.3182 18.9998C12.6697 18.9998 12.9546 18.7149 12.9546 18.3635V15.818C12.9546 15.4666 12.6697 15.1816 12.3182 15.1816Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26822 7.05063C8.01978 6.80211 7.61684 6.80215 7.36828 7.05063C7.11975 7.29915 7.11975 7.70206 7.36828 7.95058L9.16821 9.75055C9.29247 9.87481 9.45534 9.93697 9.61816 9.93697C9.78098 9.93697 9.94389 9.87481 10.0681 9.7506C10.3166 9.50208 10.3166 9.09917 10.0681 8.85065L8.26822 7.05063Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4679 14.2498C15.2194 14.0014 14.8165 14.0014 14.568 14.2498C14.3194 14.4984 14.3195 14.9013 14.568 15.1498L16.3679 16.9497C16.4922 17.0739 16.6551 17.136 16.8179 17.136C16.9808 17.136 17.1437 17.0739 17.2679 16.9497C17.5164 16.7012 17.5164 16.2982 17.2679 16.0497L15.4679 14.2498Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16817 14.2499L7.36828 16.0498C7.11975 16.2983 7.11975 16.7012 7.36828 16.9497C7.49254 17.074 7.6554 17.1361 7.81827 17.1361C7.98114 17.1361 8.144 17.074 8.26822 16.9497L10.0681 15.1498C10.3166 14.9013 10.3166 14.4984 10.0681 14.2499C9.81959 14.0013 9.41665 14.0013 9.16817 14.2499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleprocess);
export default __webpack_public_path__ + "static/media/circleprocess.c0c63ac34098af3116eac600332bbcb7.svg";
export { ForwardRef as ReactComponent };